import useTestId from '@ori/testid-generator';
import { InnerDealLabel } from "./InnerDealLabel";
import { isDealLabel } from "./isDealLabel";
import { Deal } from "./styles";
import { DEAL_LABEL } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
export var DealLabel = function DealLabel(_ref) {
  var label = _ref.label,
    type = _ref.type,
    catalogueLabel = _ref.catalogueLabel,
    catalogueUrl = _ref.catalogueUrl,
    className = _ref.className,
    offerLabelSmallerOnMobile = _ref.offerLabelSmallerOnMobile,
    productCode = _ref.productCode,
    tooltipTitle = _ref.tooltipTitle;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  if (!isDealLabel(type) || !label) {
    return null;
  }
  return /*#__PURE__*/_jsx(Deal, {
    className: className,
    "data-testid": "".concat(getTestId(DEAL_LABEL), "-").concat(productCode),
    children: /*#__PURE__*/_jsx(InnerDealLabel, {
      catalogueLabel: catalogueLabel,
      catalogueUrl: catalogueUrl,
      label: label,
      offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
      productCode: productCode,
      tooltipTitle: tooltipTitle,
      type: type
    })
  });
};
//# sourceMappingURL=DealLabel.js.map